import React from "react";
import { Card } from "ui-kit-sahadevia";
import { Bar } from "react-chartjs-2";

import { getPrice } from "../../utils/general";

export default class Statistics extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      idxModalInvoice: null,
    };
  }

  render() {
    const data = {
      labels: [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre",
      ],
      datasets: [
        {
          label: "Entrées",
          data: this.props.dataInput,
          backgroundColor: ["rgba(75, 192, 192, 0.2)"],
          borderColor: ["rgba(75, 192, 192, 1)"],
          borderWidth: 1,
        },
        {
          label: "Sorties",
          data: this.props.dataOutput,
          backgroundColor: ["rgba(255, 99, 132, 0.2)"],
          borderColor: ["rgba(255, 99, 132, 1)"],
          borderWidth: 1,
        },
      ],
    };

    const options = {
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          callbacks: {
            label: (data) => {
              const name = data.dataset.label;
              const digits = 2;

              const optionsCurrency = {
                style: "currency",
                currency: "EUR",
                minimumFractionDigits: digits,
              };
              const value = new Intl.NumberFormat(
                "fr-FR",
                optionsCurrency
              ).format(data.dataset.data[data.dataIndex]);
              return `${name} : ${value}`;
            },
          },
        },
      },
      scales: {
        y: {
          display: false,
          beginAtZero: true,
        },
        x: {},
      },
    };

    return (
      <div
        style={{ padding: "0 1rem", margin: "0 1rem", marginBottom: "1rem" }}
      >
        <Card
          title={`Satistiques : ${getPrice(this.props.totalInput)} cumulées`}
        >
          <Bar
            legend={{ display: false }}
            height="80"
            data={data}
            options={options}
          />
        </Card>
      </div>
    );
  }
}
